// extracted by mini-css-extract-plugin
module.exports = {"container":"Contact_container__GACBl","paragraph":"Contact_paragraph__tMm3r","callToAction":"Contact_callToAction__OPlat","image":"Contact_image__jpanv"};